import TextAreaWithTabs from "../../UI/TextAreaWithTabs/TextAreaWithTabs";
import React, {useState} from "react";
import * as actionTypes from "../../../store/actions/actionTypes";
import {useDispatch} from "react-redux";
import EditHistoryWrapper from "../../UI/EditHistoryPanel/EditHistoryWrapper";

const PatternDescriptionInput = ({token, pattern_description, descriptionUpdate, pattern_id}) => {
    const [activeHistory, setActiveHistory] = useState([]);

    const dispatch = useDispatch();

    function openUserProfile(userId) {
        dispatch({type: actionTypes.SELECT_USER, userId: userId});
        dispatch({type: actionTypes.OPEN_USER_MODAL});
    }

    const handleHistoryChange = (historyChange) => {
        if (historyChange) {
            if (pattern_description.description_id === historyChange.description_id) {
                descriptionUpdate(historyChange)
            } else {
                descriptionUpdate(pattern_description)
            }
        }
    }

    const handleActiveHistory = (activeHistories) => {
        setActiveHistory(activeHistories)
    }


    return <dl className="row">
        <dt className="col-sm-3"><label>Pattern Description<span style={{color: "red"}}> *</span></label></dt>
        <dd className="col-sm-9">
            <div className="example-games-block" key={"pattern-description-text-field"}>
                <div className={"example-description"}>
                    <TextAreaWithTabs
                        placeholder="Describe your pattern in detail."
                        rows="4"
                        value={pattern_description.description}
                        onChange={(event) =>
                            descriptionUpdate({...pattern_description, description: event.target.value})
                        }
                    />
                    <EditHistoryWrapper
                        style={{marginRight: 5, marginTop: 5}}
                        token={token}
                        history_id={pattern_description.history_id}
                        pattern_id={pattern_description.pattern_id}
                        component_id={pattern_description.description_id}
                        handleHistoryChange={handleHistoryChange}
                        handleActiveHistory={handleActiveHistory}
                        activeHistories={activeHistory}
                        component_text_field={pattern_description.description}
                        flag={"PATTERN_DESCRIPTION"}
                        component={pattern_description}
                        keyStr={"description-history"}
                        isActive={activeHistory.includes(pattern_description.description_id)}
                        openUserModal={() => {
                            openUserProfile(pattern_description.editor_user_id);
                        }}
                    />
                </div>
            </div>
        </dd>
    </dl>

}

export default PatternDescriptionInput;